<div class="action-panel meeting-action-panel">
  <div class="action-panel-header">
    <i class="fa fa-calendar-check-o" style="margin-right:6px;"></i>
    Schedule the {{ meetingsOrder[getIndex()] }} meeting
  </div>

  <div class="action-panel-body">
    <p class="action-panel-desc">
      Have you set a date with the project for the <strong>{{ meetingsOrder[getIndex()] }}</strong> meeting?
    </p>

    <div *ngIf="!accepted" class="yes-no-row">
      <button (click)="accept(false)" class="btn btn-default action-btn action-btn--secondary">No</button>
      <button (click)="accept(true)"  class="btn btn-primary action-btn">Yes</button>
    </div>

    <form *ngIf="accepted" [formGroup]="form" class="date-form">
      <form-error-summary [errors]="fieldErrors" (jumpTo)="jumpToField($event)"></form-error-summary>
      <div id="field-date" class="date-field" [class.date-field--invalid]="submitted && form.get('date')?.invalid">
        <label class="date-label">Meeting date</label>
        <input [formControlName]="'date'" type="date" class="form-control date-input">
      </div>
      <button (click)="confirm()" class="btn btn-primary action-btn">
        <i class="fa fa-check"></i> Save date
      </button>
    </form>
  </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
